<template>
  <div v-if="items.length === 0" class="text-center">
    <v-avatar size="25" class="avatar-color mb-0 pb-0"><v-icon  size="25"> {{ $vuetify.icons.values.account }}</v-icon></v-avatar>
    <h1 class="text-h6 font-weight-regular">{{ title }}</h1>
    <p class="text-body-2 font-weight-light">{{ message }}</p>
    <v-btn color="primary" class="mt-2 text-capitalize" @click="$emit('create')">
      {{ buttonText }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'EmptyStateButton',
  props: {
    items: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: 'No records found'
    },
    message: {
      type: String,
      default: 'List of all records will be shown here.'
    },
    buttonText: {
      type: String,
      default: 'Create'
    }
  },
};
</script>
<style>
.avatar-color{
    background-color:  var(--v-avatarColor-lighten4) !important;
}
</style>